const S = {
  G9_SAT: 27,
  G9_MINI: 29,
  G9_LCPI_SAT: 31,
  G10: 34,
  G9_MINI_OTT: 35,
  G10_LCPI: 36,
  G10_AFRIQUE: 37,
  G11: 39,
  SAMSUNG_TV: 80,
  PLAYSTATION_4: 808352,
  PLAYSTATION_5: 808353,
  LG_TV: 768420,
  HISENSE_TV: 728420,
  PHILIPS_TV: 807273,
  ORANGE_CESAR: 676983,
  ORANGE_MIB4: 777366,
  ORANGE_STELLAR: 838469,
  ORANGE_MANHATTAN: 776578,
  ORANGE_PLAY: 807665,
  ORANGE_KEY: 797522,
  PC: 806720
}, A = {
  FIRETV_REACT: "firetvreact",
  FREE_REACT: "freereact",
  G10: "g10",
  G10_LCPI: "g10lcpi",
  G11: "g11",
  G9: "g9",
  G9_LCPI: "g9lcpi",
  G9_LCPI_SAT: "g9lcpisat",
  G9_MINI: "g9mini",
  G9_SAT: "g9sat",
  HISENSE_TV: "hisensetv",
  LG_TV: "lgtv",
  ORANGE: "orange",
  ORANGE_KEY: "orangekey",
  PC: "pc",
  PHILIPS_TV: "philipstv",
  PLAYSTATION: "playstation",
  SAMSUNG_TV: "samsungtv",
  SFR: "sfr",
  UPC: "upc"
}, E = {
  "6PLAY": "6PLAY",
  ACCESS_6PLAY: "ACCESS_6PLAY",
  ACCESS_CANALPLUS_ALD: "ACCESS_CANALPLUS_ALD",
  ACCESS_CANALPLUS_SERIES: "ACCESS_CANALPLUS_SERIES",
  ACCESS_CANAL_VOD: "ACCESS_CANAL_VOD",
  ACCESS_DEUTSCHE_GRAMMOPHON: "ACCESS_DEUTSCHE_GRAMMOPHON",
  ACCESS_DISNEYPLUS: "ACCESS_DISNEYPLUS",
  ACCESS_JLO: "ACCESS_JLO",
  ACCESS_LEPORN: "ACCESS_LEPORN",
  ACCESS_MAX: "ACCESS_MAX",
  ACCESS_MOSAIQUE_BEIN_SPORTS: "ACCESS_MOSAIQUE_BEIN_SPORTS",
  ACCESS_MULTISPORTS: "ACCESS_MULTISPORTS",
  ACCESS_MYTF1: "ACCESS_MYTF1",
  ACCESS_NETFLIX: "ACCESS_NETFLIX",
  ACCESS_OPTIONAL_CHANNEL: "ACCESS_OPTIONAL_CHANNEL",
  ACCESS_OPTIONAL_CHANNEL_OFFER: "ACCESS_OPTIONAL_CHANNEL_OFFER",
  ACCESS_PARAMOUNT: "ACCESS_PARAMOUNT",
  ACCESS_PASS_PINK_X: "ACCESS_PASS_PINK_X",
  ACCESS_PASS_XXL_DORCEL: "ACCESS_PASS_XXL_DORCEL",
  ACCESS_STARZPLAY: "ACCESS_STARZPLAY",
  ACCESS_UNIVERSE: "ACCESS_UNIVERSE",
  ANONYMOUS_SERVICE: "ANONYMOUS_SERVICE",
  AUTHENTICATION: "AUTHENTICATION",
  CANALPLUS_ALD: "CANALPLUS_ALD",
  CANALPLUS_MYCANAL: "CANALPLUS_MYCANAL",
  CANALPLUS_MYCANALV5: "MYCANALV5",
  CANALPLUS_SERIES: "CANALPLUS_SERIES",
  CANAL_VOD: "CANAL_VOD",
  CHANNEL4: "CHANNEL4",
  CROSS_SELLING: "CROSS_SELLING",
  CROSS_SELLING_CANALPLUS_SERIES: "CROSS_SELLING_CANALPLUS_SERIES",
  CROSS_SELLING_DEUTSCHE_GRAMMOPHON: "CROSS_SELLING_DEUTSCHE_GRAMMOPHON",
  CROSS_SELLING_DISNEYPLUS: "CROSS_SELLING_DISNEYPLUS",
  CROSS_SELLING_JLO: "CROSS_SELLING_JLO",
  CROSS_SELLING_MAX: "CROSS_SELLING_MAX",
  CROSS_SELLING_NETFLIX: "CROSS_SELLING_NETFLIX",
  CROSS_SELLING_PARAMOUNT: "CROSS_SELLING_PARAMOUNT",
  CROSS_SELLING_PASS_PINK_X: "CROSS_SELLING_PASS_PINK_X",
  CROSS_SELLING_PASS_XXL_DORCEL: "CROSS_SELLING_PASS_XXL_DORCEL",
  CSA_DISCLAIMER: "CSA_DISCLAIMER",
  DEUTSCHE_GRAMMOPHON: "DEUTSCHE_GRAMMOPHON",
  DIAGNOSTIC: "DIAGNOSTIC",
  DISNEYPLUS: "DISNEYPLUS",
  GDPR: "gdpr",
  HIDDEN_SETTINGS: "HIDDEN_SETTINGS",
  HOME_LEGACY: "HOME_LEGACY",
  JLO: "JLO",
  LDC_MOSAIC: "LDC_MOSAIC",
  LEPORN: "LEPORN",
  MAX: "MAX",
  MAX_CONSENT: "MAX_CONSENT",
  MOSAIC: "MOSAIC",
  MOSAIQUE_BEIN_SPORTS: "MOSAIQUE_BEIN_SPORTS",
  MULTISPORTS: "MULTISPORTS",
  MY_VIDEOS: "MY_VIDEOS",
  NETFLIX: "NETFLIX",
  ONE_PROTECTION: "ONE_PROTECTION",
  ONE_SHOP: "ONE_SHOP",
  PARAMOUNT: "PARAMOUNT",
  PASS_PINK_X: "PASS_PINK_X",
  PASS_XXL_DORCEL: "PASS_XXL_DORCEL",
  PLAYER: "PLAYER",
  PURCHASE_CODE: "PURCHASE_CODE",
  SELECT_REGION: "SELECT_REGION",
  SELFCARE: "SELFCARE",
  SETTINGS: "SETTINGS",
  SOUSCRIPTION_STARZPLAY_G9: "SOUSCRIPTION_STARZPLAY_G9",
  SPARE_A: "SPARE_A",
  SPARE_B: "SPARE_B",
  SPARE_C: "SPARE_C",
  SPARE_D: "SPARE_D",
  SPARE_E: "SPARE_E",
  SPARE_F: "SPARE_F",
  STARZPLAY_G9: "STARZPLAY_G9",
  SUPPORT_INFO: "SUPPORT_INFO",
  TV_PROGRAM: "TV_PROGRAM",
  UPSELLING: "UPSELLING"
}, _ = {
  RESPONSIVE: "responsive",
  SCALED: "scaled"
}, C = {
  FAILED: "FAILED",
  LOADED: "LOADED",
  LOADING: "LOADING",
  UNLOADED: "UNLOADED",
  UNLOADING: "UNLOADING"
}, L = {
  /**
   * Not standard, stand for audioDescription.
   */
  AD: "ad",
  AR: "ar",
  CH: "ch",
  DE: "de",
  EN: "en",
  ES: "es",
  FA: "fa",
  FR: "fr",
  IT: "it",
  /**
   * Not standard.
   */
  MIS: "mis",
  /**
   * Not standard.
   */
  MUL: "mul",
  /**
   * Not standard, stand for original.
   */
  OG: "og",
  PL: "pl",
  PT: "pt",
  RU: "ru",
  TR: "tr"
}, N = {
  HD: "hd",
  UHD: "uhd",
  UHD4K: "4k",
  UHD8K: "8k"
};
export {
  _ as DisplayMode,
  L as Iso6391Code,
  N as Resolution,
  C as ServiceLoadingState,
  E as ServicesKeys,
  A as TargetGroups,
  S as TerminalTypesIds
};
//# sourceMappingURL=index.js.map
